import { CONFIGS } from "./Config";

global.baseUrl = CONFIGS.baseUrl;
global.vueBaseUrl = CONFIGS.vueBaseUrl;
global.vueDashboard = global.vueBaseUrl + "dashboard";
global.vueLogin = global.vueBaseUrl + "login";
global.disableLogs = "true";
global.version = "1.2.1";
global.getCollectionDetails = "/agent/collections/details";
global.getSchemeDetails = "/agent/collections/details-by-chit";
global.checkCollectionStatus = "/agent/collections/update-status";
global.getBlockedAgentList = "/agent/blocked-agent-list";
global.getAgentList = "/agent/agents-list";
global.getSchemeDetailsList = "/agent/scheme-list";
global.getReportList = "/agent/login_report/list";
global.updateUPIStatus = "/agent/collections/status-check";
global.getDashSummary = "/agent/dashboard/summary";
global.BlockAgent = "/agent/block-agent";
global.getAllBranches = "/getAllBranches";
global.getAllRegions = "/getAllRegions";
global.getDashMonthly = "/agent/dashboard/transaction-summary";
global.numUpdate = "/agent/settings/update-agent-number";
global.FetchLimit = "/agent/settings/collection-limit";
global.updateLimit = "/agent/settings/update-collection-limit";
global.Reports = "/agent/report/agents";
global.ReportsLogs = "/agent/report/agent-logs";
global.downloads = "/agent/report/download-agent-logs";
global.permissions = "/permissions";
global.roles = "/roles";
global.collectionLimit = "/agent/settings/update-installment-limit";
global.customerList = "/agent/get-customers";
global.customerSync = "/agent/update-chitty-data";
global.AgentCustomerSync = "/agent/fetch-customers";
global.pendingCollection = "/agent/updateCollectionCasbaStatus";
global.deleteCollection="/agent/collections/delete-collection-items"

